<div class="ng2-tag-input">
  <div class="ng2-tags-container">
    @for (chip of chips; track chip; let i = $index) {
      <span class="tag">
        <span>{{ chip.display }}</span>
        <button type="button" class="tag-remove" [disabled]="disabled" (click)="remove(i)" aria-label="Remove">&times;</button>
      </span>
    }
    <input type="email" [(ngModel)]="text" [ngModelOptions]="{ standalone: true }" [disabled]="disabled"
      [placeholder]="chips.length === 0 ? secondaryPlaceholder : placeholder"
      (keydown.enter)="onEnter($event)" (keydown.backspace)="onBackspace()" (blur)="onBlur()">
  </div>
  @for (error of errors; track error) {
    <div class="error-messages">
      <small class="text-danger">{{ error }}</small>
    </div>
  }
</div>
